module.exports = __webpack_public_path__ + "static/img/icon6.77e2bdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon6.jpg
// module id = 88/5
// module chunks = 0